import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  href: string;
  children: ReactNode;
  variant?: 'primary' | 'ghost';
  className?: string;
}

export default function Button({ href, children, variant = 'primary', className = '' }: Props) {
  const base = 'rv-btn inline-flex items-center justify-center gap-2 shrink-0 h-12 min-h-[48px] py-3 leading-5 px-6 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500 focus-visible:ring-offset-2';
  const styles = variant === 'primary'
    ? 'bg-primary-500 text-foreground-950 hover:bg-primary-600'
    : 'bg-background-50/70 text-foreground-950 border border-background-300 hover:bg-background-50';
  const cls = `${base} ${styles} ${className}`;
  if (href.startsWith('/')) return <Link to={href} className={cls}>{children}</Link>;
  return <a href={href} className={cls}>{children}</a>;
}